import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Form, Row, Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

import styles from './EsqueciSenha.module.css';
import forgotPassword from '../../api/forgotPassword';
import { encrypt } from '../../helpers/cryptography';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const EsqueciSenha = () => {
  const history = useHistory();

  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const captchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const handleRecaptcha = () => setRecaptchaToken(captchaRef.current.getValue());

  const loading = false;

  const handleModalClose = () => setShowModal(false);

  const handleChange = e => {
    setEmail(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();

    try {
      const getData = async () => {
        const data = await forgotPassword({
          email: encrypt(email),
          recaptchaToken
        });
    
        if (data?.error) {
          setErrorMessage(data?.error);
          setShowModal(true);
        } else {
          history.push('/senha-ok');
        }
      };

      getData();
    } catch (error) {
      console.log(error);
    } finally {
      captchaRef?.current?.reset();
      setRecaptchaToken(null);

      return () => null;
    }
  };

  return (
    <Row className={styles.container}>
      <Row className={styles.form_container}>
        <div className={styles.logo}>
          <div>
            <img src="../assets/img/fesaude-logo2.png" alt="Logo FeSaúde" />
          </div>
          <div>
            <h1 className={styles.title}>Redefinição de senha</h1>
          </div>
        </div>

        <Form onSubmit={handleSubmit} noValidate>
          <div className={styles.form}>
            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="email">
                  <Form.Label>*e-mail:</Form.Label>
                  <Form.Control
                    className={styles.input}
                    type="email"
                    required
                    name="email"
                    onChange={handleChange}
                    value={email}
                  />
                </Form.Group>
              </div>
            </div>
          </div>

          <div className={styles.captcha_container}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={captchaRef}
              onChange={handleRecaptcha}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>

          <div className={styles.button}>
            {loading && (
              <Button variant="flat" disabled className={styles.btn} type="submit">
                Enviando...
              </Button>
            )}

            {!loading && (
              <Button variant="flat" className={styles.btn} type="submit" disabled={!recaptchaToken ? true : false}>
                Enviar
              </Button>
            )}
          </div>
          
          <Modal show={showModal} onHide={handleModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Erro</Modal.Title>
            </Modal.Header>
            <Modal.Body>{errorMessage}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModalClose}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      </Row>
    </Row>
  );
};

export default EsqueciSenha;
